import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Menu from './components/Menu';
import TeamFlow from './components/TeamFlow'; // Your existing component
import ComercielsFoldersAndDV from './components/ComercielsFoldersAndDV'; // Example component
import RelancesFoldersAndDV from './components/RelancesFoldersAndDV'; // Example component
import SourcingFoldersAndDV from './components/SourcingFoldersAndDV'; // Example component
import BothFoldersAndDVLayout from './components/BothFoldersAndDVLayout'; // Example component
import ComandesFolders from './components/ComandesFolders'; // Example component
import RaceDashboard from './components/RaceDashboard'; // Example component

const App = () => {
  return (
    <Router>
      <div>


        {/* Routes for different components */}
        <Routes>
          <Route path="/" element={<Menu />} /> {/* Home page */}
          <Route path="/TeamFlow" element={<TeamFlow />} />
          <Route path="/ComercielsFoldersAndDV" element={<ComercielsFoldersAndDV />} />
          <Route path="/RelancesFoldersAndDV" element={<RelancesFoldersAndDV />} />
          <Route path="/SourcingFoldersAndDV" element={<SourcingFoldersAndDV />} />
          <Route path="/both-folders-and-dv" element={<BothFoldersAndDVLayout />} />
          <Route path="/commandes-folders" element={<ComandesFolders />} />
          <Route
            path="/Race Dashboard"
            element={<RaceDashboard url="https://supportinfos.approvisionneur.com" />}
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;